/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app"; // Use lowercase to ensure Linux compatibility
import { VersionManager } from "./lib/version-manager";

// Initialize version manager (handles cache busting)
VersionManager.getInstance();

// Start React app immediately - WASM loads on demand
const elem = document.getElementById("root")!;
const app = (
  <Suspense fallback={<div className="flex h-dvh items-center justify-center bg-surface-container text-on-surface"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>}>
    <App />
  </Suspense>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
